export default __webpack_public_path__ + "static/media/undraw_address_udes.d5c2d1cf.svg";